export default "__VITE_ASSET__850f50b8__"